


























import { Component, Emit, Prop, Vue } from 'vue-property-decorator'

@Component
export default class FormCard extends Vue {
  @Prop(String) title?: string
  @Prop({ type: Boolean, default: () => true }) showImage?: boolean
  @Prop({ type: Boolean, default: () => false }) showBackBtn?: boolean
  @Prop({ type: Boolean, default: () => false }) showCloseBtn?: boolean

  @Emit()
  close() {
    return true
  }

  @Emit()
  back() {
    return true
  }
}
